<template>
    <div>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-toolbar color="indigo" dense>
            <v-toolbar-title class="white--text"
                >Aggiungi evento</v-toolbar-title
            >
            <v-spacer></v-spacer>
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        class="mr-5"
                        @click="showInfo"
                        small
                        v-bind="attrs"
                        v-on="on"
                    >
                        <v-icon color="primary"> mdi-information </v-icon>
                    </v-btn>
                </template>
                <span>Informazioni query messaggio</span>
            </v-tooltip>
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        class="mr-5"
                        @click="
                            dialog_conferma_salva = true;
                            verificaModello();
                        "
                        small
                        v-bind="attrs"
                        v-on="on"
                        :disabled="check_1 == false || check_2 == false"
                    >
                        <v-icon color="success"> mdi-floppy </v-icon>
                    </v-btn>
                </template>
                <span>{{ nuovo ? "Salva e continua" : "Salva" }}</span>
            </v-tooltip>
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        class="mr-5"
                        @click="
                            dialog_conferma_salva = true;
                            verificaModello(true);
                        "
                        small
                        v-bind="attrs"
                        v-on="on"
                        :disabled="check_1 == false || check_2 == false"
                    >
                        <v-icon color="success"> mdi-content-save-move </v-icon>
                    </v-btn>
                </template>
                <span>Salva e continua</span>
            </v-tooltip>
            <v-spacer> </v-spacer>
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="clickChiudi" small v-bind="attrs" v-on="on">
                        <v-icon color="error"> mdi-keyboard-backspace </v-icon>
                    </v-btn>
                </template>
                <span>Indietro</span>
            </v-tooltip>
        </v-toolbar>
        <v-card height="90vh">
            <v-card-text>
                <v-row align="start" justify="start">
                    <v-col cols="2">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    @click="selezione = 0"
                                    v-bind="attrs"
                                    v-on="on"
                                    style="color: #0275d8"
                                >
                                    Generale
                                </v-btn>
                            </template>
                            <span>Generale</span>
                        </v-tooltip>
                    </v-col>
                    <v-col cols="2" align="center" justify="center">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    @click="selezione = 1"
                                    v-bind="attrs"
                                    v-on="on"
                                    :disabled="
                                        imp_generali != null &&
                                        imp_generali.query_evento == 'Standard'
                                    "
                                    style="color: #0275d8"
                                >
                                    Query evento
                                </v-btn>
                            </template>
                            <span>Query evento</span>
                        </v-tooltip>
                    </v-col>
                    <v-col cols="3">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    @click="selezione = 2"
                                    v-bind="attrs"
                                    v-on="on"
                                    style="color: #0275d8"
                                    :disabled="
                                        imp_generali != null &&
                                        imp_generali.query_messaggio == 'Testo'
                                    "
                                >
                                    Query messaggio
                                </v-btn>
                            </template>
                            <span>Query messaggio</span>
                        </v-tooltip>
                    </v-col>
                    <v-col cols="2">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    @click="selezione = 4"
                                    v-bind="attrs"
                                    v-on="on"
                                    style="color: #0275d8"
                                    :disabled="
                                        imp_generali != null &&
                                        imp_generali.query_messaggio == 'Testo'
                                    "
                                >
                                    Modello
                                </v-btn>
                            </template>
                            <span>Modello</span>
                        </v-tooltip>
                    </v-col>
                    <v-col cols="1">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    @click="selezione = 3"
                                    v-bind="attrs"
                                    v-on="on"
                                    :disabled="nuovo == true"
                                    style="color: #0275d8"
                                    >Azione
                                </v-btn>
                            </template>
                            <span>Azione</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
                <v-row justify="center" v-show="selezione == 0">
                    <v-col cols="12" class="py-0">
                        <ImpGenerale
                            :nuovo="nuovo"
                            :selez="selezionato"
                            ref="impGenerali" /></v-col
                ></v-row>
                <v-row justify="center" v-show="selezione == 1">
                    <v-col cols="12" class="py-0">
                        <QueryEvento
                            :database="
                                imp_generali != null
                                    ? imp_generali.db_esterno
                                    : null
                            "
                            @check_save_evento="abilitaSave1"
                            :selez="selezionato"
                            ref="queryEvento"
                        /> </v-col
                ></v-row>
                <v-row justify="center" v-show="selezione == 2">
                    <v-col cols="12" class="py-0">
                        <QueryMessaggio
                            :database="
                                imp_generali != null
                                    ? imp_generali.db_esterno
                                    : null
                            "
                            @check_save_mex="abilitaSave2"
                            :selez="selezionato"
                            ref="queryMex"
                        /> </v-col
                ></v-row>
                <v-row justify="center" v-show="selezione == 4">
                    <v-col cols="12" class="py-0">
                        <ModelloMessaggio
                            @crea_HTML="creaHTML()"
                            :selez="selezionato"
                            :nuovo="nuovo"
                            ref="modelloMex"
                        /> </v-col
                ></v-row>
                <v-row justify="center" v-show="selezione == 3" v-if="!nuovo">
                    <v-col cols="12" class="py-0">
                        <Azione :selez="selezionato" :nuovo="nuovo" /> </v-col
                ></v-row>
            </v-card-text>
        </v-card>
        <!-- DIALOG CONFERMA SALVATAGGIO -->
        <v-dialog v-model="dialog_conferma_salva" width="unset">
            <v-card>
                <v-toolbar
                    class="white--text"
                    color="indigo"
                    style="position: sticky; top: 0px; z-index: 1"
                    dense
                >
                    <v-toolbar-title>Salva</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <!-- Bottone di salvataggio -->
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="
                                    salva();
                                    dialog_conferma_salva = false;
                                "
                                small
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="success"> mdi-floppy </v-icon>
                            </v-btn>
                        </template>
                        <span>Salva</span>
                    </v-tooltip>
                    <v-spacer></v-spacer>
                    <!-- Bottone di chiusura -->
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="
                                    dialog_conferma_salva = false;
                                    modello_manca = false;
                                "
                                small
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="error"> mdi-close </v-icon>
                            </v-btn>
                        </template>
                        <span>Annulla</span>
                    </v-tooltip>
                </v-toolbar>
                <v-card-text class="mt-5 mb-0 pb-5">
                    <h2 v-if="modello_manca">
                        ATTENZIONE: non sono presenti nome o body del modello.
                    </h2>
                    <h2 class="mt-5">Salvare l'evento?</h2>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogInfo" width="50vw">
            <v-card>
                <v-toolbar
                    class="white--text"
                    color="indigo"
                    style="position: sticky; top: 0px; z-index: 1"
                    dense
                >
                    <v-toolbar-title>Informazioni</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <!-- Bottone di chiusura -->
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="dialogInfo = false"
                                small
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="error"> mdi-close </v-icon>
                            </v-btn>
                        </template>
                        <span>Annulla</span>
                    </v-tooltip>
                </v-toolbar>
                <v-card-text class="mt-5 mb-0 pb-5">
                    <h2>
                        {{dialogInfoText}}
                    </h2>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!-- Snackbar -->
        <SnackbarQV ref="SnackbarQV" />
    </div>
</template>

<script>
import ImpGenerale from "@/components/QNOTICE/ImpGenerale.vue";
import QueryEvento from "@/components/QNOTICE/QueryEvento.vue";
import QueryMessaggio from "@/components/QNOTICE/QueryMessaggio.vue";
import ModelloMessaggio from "@/components/QNOTICE/ModelloMessaggio.vue";
import Azione from "@/components/QNOTICE/Azione.vue";
import moment from "moment/moment";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
export default {
    nome: "NuovoModifica",
    components: {
        ImpGenerale,
        QueryEvento,
        QueryMessaggio,
        ModelloMessaggio,
        Azione,
        SnackbarQV,
    },
    props: ["nuovo", "selez"],
    data() {
        return {
            overlay: false,
            dialogInfoText: "",
            dialogInfo: false,
            saveContinue: false,
            dialog_conferma_salva: false,
            selezione: 0,
            // Refs dei vari componenti
            imp_generali: null,
            query_mex: null,
            modello_mex: null,
            query_evento: null,
            selezionato: this.selez,
            check_1: true,
            check_2: true,
            modello_manca: false,
        };
    },

    methods: {
        showInfo() {
            this.dialogInfoText =
                "La query messaggio deve restituire le colonne mail_object, mail_header, mail_footer, e destinatari";
            this.dialogInfo = true;
        },
        abilitaSave1(item) {
            console.log("check_save1", item);
            this.check_1 = item;
        },
        abilitaSave2(item) {
            console.log("check_save2", item);
            this.check_2 = item;
        },

        creaHTML() {
            this.query_mex = this.$refs.queryMex;
            this.modello_mex = this.$refs.modelloMex;
            let query_html = "";
            if (this.query_mex.query_mex.query != "") {
                query_html = this.query_mex.query_mex.query;

                const request = {
                    controller: "notice",
                    method: "POST",
                    richiesta: {
                        action: "gethtml",
                        token: localStorage.user_token,
                        query_messaggio: query_html,
                        database_type:
                            this.imp_generali.db_esterno != null
                                ? this.imp_generali.db_esterno.db_type.toLowerCase()
                                : null,
                        connection_string:
                            this.imp_generali.db_esterno != null
                                ? this.imp_generali.db_esterno.connection_string
                                : null,
                    },
                };

                this.$store
                    .dispatch("api6", request)
                    .then((res) => {
                        if (res.status === 200) {
                            this.modello_mex.modello.body = res.data.result;
                            console.log(res);
                        }
                    })
                    .catch((err) => {
                        // Stampo una snackbar di avviso.
                        this.$refs.SnackbarQV.print(
                            "error",
                            "Errore di comunicazione col server, non è stato possibile caricare i dati."
                        );

                        // Stampo il log dell'errore in console.
                        console.error(err);
                    });
            } else {
                this.$refs.SnackbarQV.print(
                    "orange",
                    "Inserire query messaggio."
                );
            }
        },

        clickChiudi() {
            if (this.imp_generali != null) {
                this.imp_generali.descrizione = "";
                this.imp_generali.data_inizio = null;
                this.imp_generali.data_fine = null;
                this.imp_generali.ora_inizio = "00:00:00";
                this.imp_generali.query_evento = "";
                this.imp_generali.query_messaggio = "";
                this.imp_generali.intervallo = null;
                this.imp_generali.um_delay = null;
                this.imp_generali.db_esterno = null;
                this.imp_generali.id_gruppo = null;
                this.imp_generali.if_db_esterno = 0;
                this.imp_generali.messaggi_multipli = 0;
                this.imp_generali.festivita = 0;
                this.imp_generali.ore_scelte = [];
                this.imp_generali.giorni_scelti = [];
            }

            if (this.query_mex != null) {
                if (this.query_mex.query_mex != null) {
                    this.query_mex.query_mex.query = "";
                }
            }

            if (this.query_evento != null) {
                if (this.query_evento.query_ev != null) {
                    this.query_evento.query_ev.query = "";
                }
            }

            if (this.modello_mex != null) {
                this.modello_mex.modello = {
                    id_modello: -1,
                    des_modello: "",
                    oggetto: "",
                    header: "",
                    footer: "",
                    body: "",
                };
            }
            this.$emit("click_chiudi");
        },

        formatData(arg) {
            return arg != null && arg != ""
                ? moment(arg).format("YYYY-MM-DD")
                : "";
        },

        salva() {
            this.overlay = true;
            this.imp_generali = this.$refs.impGenerali;
            this.query_mex = this.$refs.queryMex;
            this.query_evento = this.$refs.queryEvento;
            this.modello_mex = this.$refs.modelloMex;
            if (
                this.imp_generali.descrizione != "" &&
                this.imp_generali.data_inizio != null &&
                this.imp_generali.ora_inizio != null &&
                this.imp_generali.intervallo != null &&
                this.imp_generali.misura != null &&
                this.imp_generali.giorni_scelti.length != 0 &&
                this.imp_generali.ore_scelte.length != 0
            ) {
                let id_evento = null;
                if (!this.nuovo) {
                    id_evento = this.selez.id_evento;
                }

                let query_ev_save = "";
                let query_mex_save = "";
                let e_query_messaggio = 1;

                // Scelgo la query per l'evento in base al tipo
                if (this.query_evento != null) {
                    query_ev_save = this.query_evento.query_ev.query;
                }
                // Scelgo la query per il messaggio in base al tipo
                if (this.imp_generali.query_messaggio == "Testo") {
                    query_mex_save = this.imp_generali.mex_testo;
                    e_query_messaggio = 0;
                } else if (this.query_mex != null) {
                    query_mex_save = this.query_mex.query_mex.query;
                }

                console.log(this.imp_generali.id_gruppo);
                // I dati da salvare sono contenuti nei refs dei vari componenti
                const request = {
                    controller: "notice",
                    method: "PUT",
                    richiesta: {
                        action: "saveevento",
                        token: localStorage.user_token,
                        evento: [
                            {
                                id_evento: id_evento,
                                id_query: this.query_mex.id_query,
                                data_inizio: this.imp_generali.data_inizio,
                                data_fine: this.imp_generali.data_fine,
                                ora_inizio: this.imp_generali.ora_inizio,
                                ora_fine: null,
                                db_esterno: this.imp_generali.if_db_esterno,
                                id_database:
                                    this.imp_generali.db_esterno != null
                                        ? this.imp_generali.db_esterno.id
                                        : null,
                                is_query: e_query_messaggio,
                                query_messaggio: query_mex_save,
                                query_evento: query_ev_save,
                                delay: this.imp_generali.intervallo,
                                um_delay: this.imp_generali.misura,
                                descrizione: this.imp_generali.descrizione,
                                multiple_messages:
                                    this.imp_generali.messaggi_multipli,
                                orari_abilitati:
                                    this.imp_generali.ore_scelte.toString(),
                                giorni_abilitati:
                                    this.imp_generali.giorni_scelti.toString(),
                                festivi_abilitati: this.imp_generali.festivita,
                                id_gruppo: this.imp_generali.id_gruppo,
                                status: this.nuovo ? 1 : this.selez.status,
                                validita: 1,
                                id_evento_email_modello:
                                    this.modello_mex.modello.id_modello,
                                des_modello:
                                    this.modello_mex.modello.des_modello,
                                oggetto: this.modello_mex.modello.oggetto,
                                header: this.modello_mex.modello.header,
                                footer: this.modello_mex.modello.footer,
                                body: this.modello_mex.modello.body,
                            },
                        ],
                    },
                };

                this.$store
                    .dispatch("api6", request)
                    .then((res) => {
                        this.overlay = false;
                        if (res.status === 200) {
                            console.log("salvataggio fatto");
                            // Stampo una snackbar di conferma.
                            this.$refs.SnackbarQV.print(
                                "success",
                                "Salvataggio effettuato."
                            );
                            if (!this.nuovo && !this.saveContinue) {
                                // Pulisco i riferimenti dell'evento salvato
                                this.imp_generali.descrizione = "";
                                this.imp_generali.data_inizio = null;
                                this.imp_generali.data_fine = null;
                                this.imp_generali.query_messaggio = "";
                                this.imp_generali.intervallo = null;
                                this.imp_generali.um_delay = null;
                                this.imp_generali.festivita = 0;
                                this.imp_generali.ore_scelte = [];
                                this.imp_generali.giorni_scelti = [];
                                this.imp_generali.db_esterno = null;
                                this.imp_generali.if_db_esterno = 0;
                                this.imp_generali.id_gruppo = null;
                                this.imp_generali.ora_inizio = "00:00:00";
                                this.$emit("salvataggio_effettuato");
                                this.$emit("click_chiudi");
                            } else {
                                // Da verificare
                                this.selezionato = res.data.result[0];
                                this.selez = res.data.result[0];
                                this.nuovo = false;
                            }
                        }
                    })
                    .catch((err) => {
                        this.overlay = false;
                        // Stampo una snackbar di avviso.
                        this.$refs.SnackbarQV.print(
                            "error",
                            "Errore di comunicazione col server, non è stato possibile caricare i dati."
                        );

                        // Stampo il log dell'errore in console.
                        console.error(err);
                    });
            } else {
                this.overlay = false;
                this.$refs.SnackbarQV.print(
                    "orange",
                    "Compilare descrizione, data e ora di inizio, intervallo, unità di tempo, giorni selezionati e ore."
                );
            }
        },
        verificaModello(arg = false) {
            this.saveContinue = arg;
            this.modello_mex = this.$refs.modelloMex;
            if (
                !this.modello_mex.modello.body ||
                !this.modello_mex.modello.des_modello
            ) {
                this.modello_manca = true;
            }
            console.log(
                this.modello_mex.modello.body,
                "+",
                this.modello_mex.modello.des_modello
            );
            console.log(this.modello_manca);
        },
    },

    computed: {},

    watch: {},

    mounted() {
        this.imp_generali = this.$refs.impGenerali;
        console.log(this.selez);
    },
};
</script>
<style scoped></style>
